import type { FlexProps } from './Flex.props'

const Flex = ({
  children,
  style,

  alignContent,
  alignItems,
  alignSelf,
  flexBasis,
  flexDirection,
  flexGrow,
  flexShrink,
  flexWrap,
  gap,
  justifyContent,
  justifyItems,

  ...remainingProps
}: FlexProps) => {
  return (
    <div
      style={{
        ...style,

        display: 'flex',
        alignContent,
        alignItems,
        alignSelf,
        flexBasis,
        flexDirection,
        flexGrow,
        flexShrink,
        flexWrap,
        gap,
        justifyContent,
        justifyItems,
      }}
      {...remainingProps}
    >
      {children}
    </div>
  )
}

const FlexColumn = (props: Omit<FlexProps, 'flexDirection'>) => <Flex flexDirection='column' {...props} />

const FlexRow = (props: Omit<FlexProps, 'flexDirection'>) => <Flex flexDirection='row' {...props} />

export { Flex, FlexColumn, FlexRow }
